import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4aff02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date_time_picker" }
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "time" }

import DatePicker from '@/components/atoms/DatePicker.vue'
import TimeSelector from '@/components/atoms/TimeSelector.vue'
import TimePicker from '@/components/atoms/TimePicker.vue'
import { getDateStr } from '@/js/utils/date'
import { computed, withDefaults, reactive } from 'vue'

type ModelValue = {
  date: Date | null
  time: string | null
}

type PropsType = {
  modelValue?: ModelValue
  disabledDate?: (date: Date) => boolean
  type?: string
  maxTime?: string
  disabled?: boolean
  timePickerOptions?: {}
  disabledHours?: () => number[]
  disabledMinutes?: (hour: number) => number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimePicker',
  props: {
    modelValue: { default: () => ({
    date: null,
    time: null,
  }) },
    disabledDate: { type: Function, default: (date: Date): boolean => {
    return date > new Date()
  } },
    type: { default: 'TimeSelector' },
    maxTime: { default: '23:59' },
    disabled: { type: Boolean, default: false },
    timePickerOptions: null,
    disabledHours: null,
    disabledMinutes: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: ModelValue): void
  (e: 'change', value: ModelValue): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: ModelValue, disabledDate: (date: Date) => boolean, type: string, maxTime: string, disabled: boolean, timePickerOptions?: {}, disabledHours?: () => number[], disabledMinutes?: (hour: number) => number[] };





const state = reactive({
  selectedValue: props.modelValue,
})

const maximumTime = computed(() => {
  //  制限時間を設定して今日の場合最大時間変更
  if (
    state.selectedValue.date &&
    getDateStr(state.selectedValue.date) === getDateStr(new Date()) &&
    props.maxTime !== '23:59'
  ) {
    return props.maxTime
  }
  return '23:59'
})

const changeDate = (value: Date) => {
  state.selectedValue.date = value
  emit('update:modelValue', state.selectedValue)
  // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
  emit('change', state.selectedValue)
}

const changeTime = (value: string) => {
  state.selectedValue.time = value
  emit('update:modelValue', state.selectedValue)
  // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
  emit('change', state.selectedValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(DatePicker, {
        modelValue: state.selectedValue.date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.selectedValue.date) = $event)),
        "disabled-date": __props.disabledDate,
        disabled: __props.disabled,
        onChange: changeDate
      }, null, 8, ["modelValue", "disabled-date", "disabled"])
    ]),
    _createElementVNode("span", _hoisted_3, [
      (__props.type === 'TimeSelector')
        ? (_openBlock(), _createBlock(TimeSelector, {
            key: 0,
            modelValue: state.selectedValue.time,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.selectedValue.time) = $event)),
            disabled: __props.disabled,
            "picker-options": __props.timePickerOptions,
            onChange: changeTime
          }, null, 8, ["modelValue", "disabled", "picker-options"]))
        : (_openBlock(), _createBlock(TimePicker, {
            key: 1,
            modelValue: state.selectedValue.time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.selectedValue.time) = $event)),
            "max-time": _unref(maximumTime),
            disabled: __props.disabled,
            "disabled-hours": __props.disabledHours,
            "disabled-minutes": __props.disabledMinutes,
            onChange: changeTime
          }, null, 8, ["modelValue", "max-time", "disabled", "disabled-hours", "disabled-minutes"]))
    ])
  ]))
}
}

})